<div
	class="
        w-fit
        h-full
        bg-neutral-500
        shadow-component
        px-5
        rounded-[20px]
        border-2
        border-neutral-800
        flex
        items-center
        {$$restProps.class}
    "
>
	<slot />
</div>
